import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface ServiceFeatureProps {
  icon: BoxIcon;
  title: string;
  description: string;
  index: number;
}
export function ServiceFeature({
  icon: Icon,
  title,
  description,
  index
}: ServiceFeatureProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: index * 0.1,
    duration: 0.5
  }} className="relative group" data-id="element-509">
      <div className="bg-gradient-to-br from-[#1A2228] to-[#0F161B] border border-white/10 rounded-2xl p-8 hover:border-[#DDA247]/30 transition-all duration-300" data-id="element-510">
        {/* Icon */}
        <div className="w-16 h-16 bg-[#DDA247]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#DDA247]/20 transition-colors" data-id="element-511">
          <Icon className="w-8 h-8 text-[#DDA247]" data-id="element-512" />
        </div>

        {/* Content */}
        <h3 className="text-xl font-bold text-white mb-3 uppercase tracking-wide" data-id="element-513">
          {title}
        </h3>
        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-514">{description}</p>

        {/* Decorative element */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#DDA247]/5 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-515" />
      </div>
    </motion.div>;
}